import { H2 } from '@berlitz/globals'
import styled, { css } from 'styled-components'
import { StyledAvatar } from '../../../components/Header/style'

export const Header = styled(H2)`
  color: ${({ theme }) => theme.palette.charcoal};
  margin-bottom: ${({ theme }) => theme.space.md};
`

export const ViewProfile = styled.div`
  background: ${({ theme }) => theme.palette.blue20};
  display: flex;
  width: 215px;
  padding: 10px 8px;
  margin-bottom: 30px;
`

export const TextAreaHeader = styled.div`
  color: ${({ theme }) => theme.palette.charcoal};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  font-size: ${({ theme }) => theme.fontSize.xxs};
  line-height: 1.14;
  letter-spacing: 0.49px;
  margin-bottom: 4px;
`

export const AvatarCircle = styled(StyledAvatar)`
  background-color: ${({ theme }) => theme.palette.red100};
  margin-right: 15px;
`

export const ViewUrl = styled.a`
  cursor: pointer;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.brandPrimary};
  align-self: center;
`

export const TipBox = styled.div`
  color: ${({ theme }) => theme.palette.charcoal};
  background: ${({ theme }) => theme.palette.blue20};
  border-radius: 3px;
  padding: 10px 20px;

  h3 {
    margin-bottom: 12px;
    font-weight: ${({ theme }) => theme.fontWeight.bold};
  }

  li {
    font-size: ${({ theme }) => theme.fontSize.xxs};
    line-height: 1.14;
    letter-spacing: 0.49px;
    margin-bottom: 5px;
  }

  ul li::before {
    content: '•';
    color: ${({ theme }) => theme.colors.brandPrimary};
    font-weight: bold;
    display: inline-block;
    width: 1em;
  }
`

export const StatusText = styled.span`
  font-size: ${({ theme }) => theme.fontSize.xs};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`

export const StatusInfo = styled.span<{ approved: boolean }>`
  font-size: ${({ theme }) => theme.fontSize.xs};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme, approved }) => (approved ? theme.palette.success100 : theme.palette.warning100)};
  margin-right: 15px;
  svg {
    color: ${({ theme, approved }) => (approved ? theme.palette.success100 : theme.palette.warning100)};
  }
`
